export default "__VITE_ASSET__2a5ee61f__"